import { Tile } from './models/tile';

export class TileListUtils {
    static isTile(obj: any): obj is Tile {
        return (
            obj &&
            typeof obj.id === 'string' &&
            typeof obj.iconClass === 'string' &&
            typeof obj.name === 'string'
        );
    }
}
